import { render } from "./BalanceGroupControl.vue?vue&type=template&id=a4478022&scoped=true"
import script from "./BalanceGroupControl.vue?vue&type=script&lang=js"
export * from "./BalanceGroupControl.vue?vue&type=script&lang=js"

import "./BalanceGroupControl.vue?vue&type=style&index=0&id=a4478022&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4478022"]])

export default __exports__